import { isNullish } from "@apollo/client/cache/inmemory/helpers";
import { Logger } from '@module/logger';

const SSR = import.meta.env.SSR;

// const logger = new Logger("Apollo SSR");

export function defaultDataIdFromObject(_a: Record<string, any>, context?: Record<string, any>) {
  var __typename = _a.__typename,
    site = _a.site || _a.siteHandle || _a.siteId,
    id = _a.id,
    _id = _a._id;

  if (typeof __typename === "string") {
    if (context) {
      context.keyObject = !isNullish(id) ? { id: id } : !isNullish(_id) ? { _id: _id } : void 0;
    }
    // If there is no object.id, fall back to object._id.
    if (isNullish(id) && !isNullish(_id)) {
      id = _id;
    }
    if (!isNullish(id)) {
      var res = "".concat(__typename, ":");
      if (typeof site === "string" || typeof site === "number")
        res = res.concat(`${site}`, "/")
      return res.concat((typeof id === "number" || typeof id === "string") ? `${id}` : JSON.stringify(id));
    }
  }
}

export function urlDeleteRefresh(url: string) {
  if (typeof url !== "string")
    return url;

  const _url = new URL(url);
  _url.searchParams.delete("refresh");
  return _url.href;
}